import angular from "angular";

angular
    .module('app')
    .component('fileUploadModal', {
        template: require('./file-upload-modal.html'),
        controller: ['$http', 'Notifier', 'Upload', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, Notifier, Upload) {

    let $ctrl = this;


    $ctrl.newFileName = null;
    $ctrl.file = null;
    $ctrl.$onInit = function () {

        $ctrl.course = $ctrl.resolve.course;
        $ctrl.lesson = $ctrl.resolve.lesson;
    };


    $ctrl.submit = function () {
        $ctrl.loading = true;
        $ctrl.file = Upload.rename($ctrl.file, $ctrl.newFileName +'.'+ getFileExtension($ctrl.file.name));
        Upload
            .upload({
                url: `/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/upload-files`,
                data: {
                    file: $ctrl.file,
                },
            })
            .then(
                function (response) {
                    $ctrl.file = null;
                    $ctrl.loading = false;
                    $ctrl.close({
                        $value: {
                            id: response.data.file.id,
                            name: response.data.file.name,
                            file_url: response.data.file.file_url,
                        }
                    });
                    Notifier.success('Файл успешно загружен', 2);
                },
                function (error) {
                    $ctrl.loading = false;
                    Notifier.error('Произошла ошибка', 2);
                },
                function (evt) {
                }
            );

    };

    $ctrl.setName = function () {
        $ctrl.newFileName = $ctrl.file.name;
        $ctrl.newFileName = $ctrl.newFileName.split('.').slice(0,-1).join('.');
    };

    function getFileExtension(filename) {
        return filename
            .split('.')
            .slice(-1)[0];
    }
}
